<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
		</el-col>

		<!--列表 @selection-change="handleSelectionChange"-->
		<el-table :data="tableData" highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column prop="userid" label="用户ID" width="140">
			</el-table-column>
			<el-table-column prop="avatar" label="头像" width="80">
				<template slot-scope="image">
                    <img class="avatar" :src="image.row.avatar?image.row.avatar:require('../../assets/avatar.png')"  min-width="70" height="70" />
                 </template>
			</el-table-column>
			<el-table-column prop="name" label="姓名" max-width="180">
			</el-table-column>
			<el-table-column prop="phone" label="电话" max-width="180">
			</el-table-column>
			<el-table-column prop="companyName" label="公司" max-width="180">
			</el-table-column>
			<el-table-column prop="vocation" label="行业" max-width="180">
			</el-table-column>
			<el-table-column prop="remark" label="备注" max-width="180">
			</el-table-column>
			<el-table-column prop="updateTime" label="提交时间" :formatter='formateDate1' max-width="180">
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next, jumper, sizes" @current-change="handleCurrentChange"
				@size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage"
				:page-size="pageSize" :total="totalNumber" style="float:left;">
			</el-pagination>
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.multipleSelection.length===0"
				style="float:right;">批量下架</el-button> -->

		</el-col>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	//import NProgress from 'nprogress'
	import { getUserListPage, removeUser, batchRemoveUser, editUser, addUser } from '../../api/api';

	export default {
		data() {
			return {
				loadingPass: false,
				loadingUnpass: false,
				checkVisible: false,
				settingVisible: false,
				currentId: null,
				currentItem: null,
				chargeFormVisible: false,
				selcetedCheckState: null,
				selectedState: null,
				multipleSelection: [],
				totalNumber: null,
				tableData: null,
				pageSize: 10,
				currentPage: 1,
				statusState: [{ label: '待处理', value: 'WAITING' }, { label: '已处理', value: 'COMPLETE' },],
				checkState: [{ label: '审核中', value: 'WAITING' }, { label: '审核通过', value: 'PASSED' }, { label: '不通过', value: 'REJECTED' }],
				filters: {
					name: ''
				},
				users: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入金额', trigger: 'blur' }
					]
				},
				//新增界面数据
				addForm: {
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},
				chargeLoading: false,
				chargeForm: {
					money: 0,
				}

			}
		},
		methods: {
			async setCheckState(index) {
				let state = 'WAITING'
				if (index == 0) {
					this.loadingUnpass = true;
					state = 'REJECTED'
				} else {
					this.loadingPass = true;
					state = 'PASSED'
				}
				try {
					let result = await this.$http.post(this,`/project/${this.currentId}/audit/${state}`);
					if (index == 0) {
						this.loadingUnpass = false;
					} else {
						this.loadingPass = false;
					}
					if (result && result.code == 200) {
						this.$message({
							message: '完成',
							type: 'success'
						});
						this.getList(this.currentPage - 1);
					}
				} catch (e) {
					this.loadingPass = false;
					this.loadingUnpass = false;
				}
				this.checkVisible = false;
			},
			handleSelectionChange(val) {
				console.log('checkb0x-', val)
				this.multipleSelection = val;
			},
		formatDatas(item) {
				return {
					// userid: item.user&&item.user.id,
					// avatar: item.user&&item.user.avatar||'',
					// name: item.user&&item.user.nickName||item.user.username||'',
					// phone: item.info&&item.info.phone||'',
					// companyName: item.info&&item.info.companyName||'',
					// vocation: item.info&&item.info.vocation||'',
					// remark: item.info&&item.info.remark||'',
					// updateTime: item.info&&item.info.updateTime||'',
          userid: item&&item.id,
          avatar: item&&item.avatar||'',
          name: item&&(item.nickName||item.username||''),
          phone: item&&item.phone||'',
          companyName: item&&item.companyName||'',
          vocation: item&&item.vocation||'',
          remark: item&&item.remark||'',
          updateTime: item&&item.updateTime||'',
				};
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList(this.currentPage - 1);
			},
			getFilterList() {
				this.currentPage = 1;
				this.getList(this.currentPage - 1);
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getList(this.currentPage - 1);
			},
			async getList(index) {
				this.cancel&&this.cancel();
				let query = { pageIndex: index, pageSize: this.pageSize };
				let url =`/project/${this.$route.query.id}/form/users`
				let result = await this.$http.get(this,url,query ,null,(cancel)=>{this.cancel = cancel});
				if (result && result.code == 200) {
					this.tableData = result.data.data.map((item) => { return this.formatDatas(item) });
					this.totalNumber = result.data.count
				}
			},
			formatCheckState(row, column) {
				let temp = this.checkState.filter((item) => {
					return item.value == row.auditState;
				})
				return temp[0].label;
			},
			formateDate(row, column) {
				if (!row.createTime) {
					return '';
				}
				return new Date(row.createTime).format("yyyy/MM/dd hh:mm");
			},
			formateStatus(row, column) {
				if (!row.status) {
					return '';
				} else if (row.status == 'COMPLETE') {
					return '已处理';
				} else if (row.status == 'WAITING') {
					return '待处理';
				}
				return '';
			},
			formateDate1(row, column) {
				if (!row.updateTime) {
					return '';
				}
				return new Date(row.updateTime).format("yyyy/MM/dd hh:mm");
			},
			handleCharge: function (index, row) {
				this.currentId = row.id;
				this.chargeFormVisible = true;
			},
			handleCheck: function (index, row) {
				this.currentId = row.id;
				this.$confirm('您确认已经将客户提现金转给客户？', '提现', {}).then(async () => {
					try{
						await this.withdrawalAccept(row.id);
						this.getList(this.currentPage - 1);
					} catch(e) {
						this.$message({
						message: '处理失败，请重试',
						type: 'fail'
					});
					}

				});
			},
			async withdrawalAccept(id) {
				let url = `/withdrawal/${id}/complete`
				let result = await this.$http.post(this,url);
				if (result && result.code == 200) {
					this.$message({
						message: '处理成功',
						type: 'success'
					});
				}
			},
			handleSetting: function (index, row) {
				this.settingVisible = true;
				//this.currentId = row.id;
				this.currentItem = this.tableData.filter((item)=>{
					return row.id == item.id;
				})[0]
				console.log('this.currentItem--',this.currentItem)
			},
			//显示新增界面
			handleAdd: function () {
				this.$router.push('/table/table1')
				this.addFormVisible = true;
				this.addForm = {
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							editUser(para).then((res) => {
								this.editLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								//	this.getUsers();
							});
						});
					}
				});
			},
			chargeSubmit() {
				this.$refs.chargeform.validate(async (valid) => {
					if (valid) {
						this.chargeLoading = true;
						let para = {
							amount: this.chargeForm.money,
						}
						let result = await this.$http.post(this,`/project/${this.currentId}/recharge`, para);
						if (result.code == 200) {
							this.chargeLoading = false;
							this.$message({
								message: '充值成功',
								type: 'success'
							});
							this.chargeForm.money = 0;
							this.chargeFormVisible = false;
							this.getList(this.currentPage - 1);
						} else {
							this.$message({
								message: '充值失败',
								type: 'fail'
							});
						}
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.addForm);
							para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							addUser(para).then((res) => {
								this.addLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['addForm'].resetFields();
								this.addFormVisible = false;
								//this.getUsers();
							});
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					batchRemoveUser(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						//this.getUsers();
					});
				}).catch(() => {

				});
			}
		},
		mounted() {
			this.getList(0);
		}
	}

</script>

<style scoped>
	.el-button+.el-button {
		margin-left: 4px;
	}

	.el-button--small,
	.el-button--small.is-round {
		padding: 8px 10px;
	}

	.el-button--text {
		padding-left: 0;
		padding-right: 0;
	}
	.work-image {
		width: 200px;
		height: auto;
	}
	.avatar {
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}
</style>
